import React, { useCallback, useMemo } from "react";

import { SelectWrapper, StyledSelect } from "./styles";
import { DotSpinner } from "@smartrr/shared/customerPortal/components/DotSpinner";

interface Props<V extends string | number | undefined>
  extends Omit<React.HTMLAttributes<HTMLSelectElement>, "onChange"> {
  noBorder?: boolean;
  options: { label: string; value: V }[];
  onChange(e: V): void;
  value?: V;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
}

export function Select<V extends string | number | undefined>({
  noBorder,
  options,
  onChange,
  value,
  isLoading,
  disabled,
  className,
  ...rest
}: Props<V>): JSX.Element {
  const selectOnChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      if (onChange) {
        onChange(e.target.value as V);
      }
    },
    [onChange]
  );

  const tempId = useMemo(() => `${Math.random()}`, []);

  return (
    <SelectWrapper disabled={disabled} htmlFor={tempId} noBorder={noBorder} className={className}>
      {isLoading ? (
        <DotSpinner />
      ) : (
        <StyledSelect
          disabled={disabled}
          id={tempId}
          onChange={selectOnChange}
          value={value}
          noBorder={noBorder}
          {...rest}
        >
          {options.map(o => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </StyledSelect>
      )}
    </SelectWrapper>
  );
}
